import __var_0__ from './mode.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Weibull distribution mode.
*
* @module @stdlib/stats/base/dists/weibull/mode
*
* @example
* var mode = require( '@stdlib/stats/base/dists/weibull/mode' );
*
* var v = mode( 1.0, 1.0 );
* // returns 0.0
*
* v = mode( 4.0, 12.0 );
* // returns ~11.167
*
* v = mode( 8.0, 2.0 );
* // returns ~1.967
*/

// MODULES //
var mode = __var_0__;


// EXPORTS //
export default mode;
